import { render } from "./Plug.vue?vue&type=template&id=1978c10c&scoped=true"
import script from "./Plug.vue?vue&type=script&lang=js"
export * from "./Plug.vue?vue&type=script&lang=js"

import "./Plug.vue?vue&type=style&index=0&id=1978c10c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\houselayout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1978c10c"]])

export default __exports__